var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Widget from '../Widget';
var ChildItemWidget = function (props) {
    var item = props.item, identifier = props.identifier, restProps = __rest(props, ["item", "identifier"]);
    return item && item.length > 0
        ? item.map(function (itemProps, index) {
            var attributes = itemProps.attributes, itemRestProps = __rest(itemProps, ["attributes"]);
            return (React.createElement(Widget, __assign({ key: identifier + "-" + index, type: "item", attributes: attributes || {}, parentIdentifier: identifier }, itemRestProps, { parentWidget: restProps })));
        })
        : null;
};
export default ChildItemWidget;
//# sourceMappingURL=index.js.map